export const userProfileRecordStatus = [
  { key: "O", badgeColor: "success" },
  { key: "C", badgeColor: "danger" },
];

export const userProfileRole = [
  { value: 1, label: "LOG_ADMIN" },
  { value: 4, label: "HUB_ADMIN" },
  { value: 2, label: "RUNNER" },
  { value: 3, label: "SALE" },
  { value: 5, label: "COLLECTOR" },
];

export const userProfileRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const userProfileModeList = {
  VIEW_USER_PROFILE_DETAIL: "VIEW_USER_PROFILE_DETAIL",
  EDIT_USER_PROFILE_DETAIL: "EDIT_USER_PROFILE_DETAIL",
};

export const getInitUserProfileParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
  };
};
